import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import {
  selectDamagesAdditionalFormData,
  selectArePreviousDamagePresent,
  selectAreOtherDamagesPresent,
} from "../damages.selectors";
import {
  setAreOtherDamagesPresent,
  setPreviousDamagePresent,
} from "../damages.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.DAMAGES_ADDITIONAL,
  selector: selectDamagesAdditionalFormData,
  content: [
    {
      sections: [
        {
          id: "additional-form-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.ARE_PREVIOUS_DAMAGE_PRESENT,
              label:
                "Czy mienie przed zdarzeniem posiadało jakieś nienaprawione uszkodzenia?",
              required: true,
              onChange: setPreviousDamagePresent,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "additional-form-data-2",
          isVisible: selectArePreviousDamagePresent,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.PREVIOUS_DAMAGE_DESCRIPTION,
              label: "Opis wcześniejszych uszkodzeń",
              required: true,
              limit: 100,
              placeholder: "Opisz uszkodzenia swojego mienia",
            },
          ],
        },
        {
          id: "additional-form-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.ARE_OTHER_DAMAGES_PRESENT,
              onChange: setAreOtherDamagesPresent,
              label:
                "Czy powstały inne szkody rzeczowe poza uszkodzonym mieniem?",
              required: true,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "additional-form-data-4",
          isVisible: selectAreOtherDamagesPresent,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.OTHER_DAMAGES_DESCRIPTION,
              label: "",
              required: true,
              limit: 100,
              placeholder: "Opisz inne szkody rzeczowe",
            },
          ],
        },
        {
          id: "additional-form-data-5",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.PROPERTY_PLACE,
              label: "Gdzie możemy obejrzeć uszkodzone mienie?",
              required: true,
              limit: 500,
              placeholder:
                "Podaj adres gdzie możemy obejrzeć uszkodzone mienie",
            },
          ],
        },
      ],
    },
  ],
};
